import { PropsWithChildren, useReducer } from 'react';

import { WebhookContext } from './context';
import { WebhookReducer, getInitialState } from './reducer';

export const WebhookContextProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const [state, dispatch] = useReducer(WebhookReducer, getInitialState());

  return (
    <WebhookContext.Provider value={{ webhookState: state, webhookDispatch: dispatch }}>
      {children}
    </WebhookContext.Provider>
  );
};
